import React, { Component } from "react";
import { Grid, Row, Col } from "react-bootstrap";

import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import HttpLinkServices from "../../services/HttpLinkServices";
import Config from "../../config/config";
import { addToDataLayerGTM } from "../../utils/addToDataLayerGTM";
import SearchNotFound from "../../components/SearchNotFound";
import ErrorModal from "../../components/Modal/ErrorModal";
import banner_default from '../../assets/img/Bn_Favoritos_2021.jpg';

const lms_client = new ApolloClient({
  link: HttpLinkServices.lms,
  cache: new InMemoryCache()
});

const GET_CURSES = gql`
  {
    courses_favorites_by_user {
      UserFavoriteCourse {
        id
        course {
          id
          title
          thumbnail
        }
      }
    }
  }
`;

class Favorites extends Component {
  createLegend(json) {
    var legend = [];
    for (var i = 0; i < json["names"].length; i++) {
      var type = "fa fa-circle text-" + json["types"][i];
      legend.push(<i className={type} key={i} />);
      legend.push(" ");
      legend.push(json["names"][i]);
    }
    return legend;
  }
  componentDidMount() {
    // Google Tag Manager
    const dataLayer = {
      'event': "step_change",
      'etapa': "/cursos/cursos-favoritos/"
    };

    addToDataLayerGTM(dataLayer);
  }
  render() {
    return (
      <div>
        <Query
          client={lms_client}
          query={GET_CURSES}
        >
        {({ loading, error, data }) => {
          if (loading) return <div>Carregando...</div>;
          if (error){
            // Google Tag Manager
            addToDataLayerGTM({
              'event' : 'erro',
              'etapa' : 'erro ao buscar categorias'
            });
            return <ErrorModal />;
          };

            return (
              <img className="banner_content" src={data.category && data.category.banner ? Config.baseUrl + "/dam/assets/" + data.category.banner : banner_default} />
            );
          }}
        </Query>
        <div className="content">
          <div className="container">
            <Grid fluid>
              <Row>
                <Query client={lms_client} query={GET_CURSES}>
                  {({ loading, error, data }) => {
                    if (loading) return <div>Carregando...</div>;
                    if (error) {
                      // Google Tag Manager
                      addToDataLayerGTM({
                        'event': 'erro',
                        'etapa': 'erro ao buscar os cursos'
                      });

                      return <ErrorModal />;
                    };

                    if (
                      !data.courses_favorites_by_user ||
                      !data.courses_favorites_by_user.UserFavoriteCourse.length
                    ) {
                      return (
                        <SearchNotFound
                          message="Nenhum curso adicionado aos favoritos."
                          onClick={() => (window.location.href = "/#/home")}
                          buttonMessage="Voltar a página inicial"
                        />
                      );
                    }
                    
                    return data.courses_favorites_by_user.UserFavoriteCourse.map(
                      item => (
                        <Col lg={4} sm={6} className="col" key={item.id}>
                          <div className="media">
                            <a
                              data-gtm-type="click"
                              data-gtm-clicktype="card"
                              data-gtm-name={item.course.title}
                              href={"/#/curso/" + item.course.id}
                            >
                              <img
                                src={
                                  Config.baseUrl +
                                  "/lms/assets/" +
                                  item.course.thumbnail
                                }
                              />
                              <div>{item.course.title}</div>
                            </a>
                          </div>
                        </Col>
                      )
                    );
                  }}
                </Query>
              </Row>
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default Favorites;



// WEBPACK FOOTER //
// ./src/views/Courses/Favorites.jsx